export default __webpack_public_path__ + "static/about-hero-8f2a2f77589a19f250261aa248fd698a.jpg";